// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FetchAreaId } from './FetchAreaId'
import { FetchAreaNavigation } from './FetchAreaNavigation'
import { FetchAreaRoutes } from './FetchAreaRoutes'

const LazyFetchComponent = lazy(() => import('./FetchArea'))

const FetchComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFetchComponent />
  </SuspenseLoadingWrapper>
)

export const FetchArea = {
  id: FetchAreaId,
  requiredRight: BoumRight.AREA_FETCH,
  NavigationComponent: FetchAreaNavigation,
  route: {
    path: FetchAreaRoutes.route,
    component: FetchComponent,
  },
}
